export default __webpack_public_path__ + "static/media/howfortune.90e23c00.svg";